import DefaultAwardIcon from '@assets/icons/DefaultAwardIcon'
import { useDialog } from '@globals/dialog/useDialogStore'
import { AwardType } from '@kudos/http-client'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import EngagementDialogWithMobileDrawer from '@shared/dialog/EngagementDialogWithMobileDrawer'
import { T } from '@transifex/react'
import { format } from 'date-fns'
import { FC } from 'react'
import AwardTypePointsChip from '../sendAward/AwardTypePointsChip'
import NominateForm from './NominateForm'
import PastNominations from './PastNominations'
import { useSendNominationFormStore } from './useSendNominationFormStore'

export const SEND_NOMINATIONS_MODAL_KEY = 'sendNominationsModalKey'

export type SendNominationsDialogData = {
  nomination: AwardType
  isPinned?: boolean
}

const SendNominationsModal: FC = () => {
  const { dialogData: data } = useDialog<SendNominationsDialogData>(SEND_NOMINATIONS_MODAL_KEY)
  const { isFormDirty } = useSendNominationFormStore()

  return (
    data?.nomination && (
      <EngagementDialogWithMobileDrawer
        dialogKey={SEND_NOMINATIONS_MODAL_KEY}
        isFormDirty={isFormDirty}
        avatarUrls={data.nomination.attachmentUrls}
        defaultIcon={<DefaultAwardIcon />}
        subtitle={
          data.nomination.nominationEndAt && (
            <T
              _str="Nominations close {date}"
              date={format(data.nomination.nominationEndAt, 'PPPp')}
            />
          )
        }
        chip={
          <AwardTypePointsChip
            points={data.nomination.points}
            pointsLocked={data.nomination.pointsLocked}
            isNomination
          />
        }
        title={data.nomination.name}>
        <>
          <Stack spacing={2} pt={{ xs: 2, lg: 0 }}>
            <Typography variant="body1">{data.nomination.description}</Typography>
            <PastNominations
              ownNominees={data.nomination.ownNominees}
              nominationId={data.nomination.id}
            />
          </Stack>
          <NominateForm nomination={data.nomination} isPinned={data.isPinned} />
        </>
      </EngagementDialogWithMobileDrawer>
    )
  )
}

export default SendNominationsModal
